import { Space } from 'antd';
import styled from 'styled-components';

import { Button } from '@atom/button/button';

export const NewWebhookButton = styled(Button)`
  max-width: 320px;
`;

export const Wrapper = styled.div`
  padding-top: 24px;
`;

export const FooterWrapper = styled(Space).attrs({
  direction: 'horizontal',
})`
  padding-top: 24px;
`;
